import React from 'react';

const Switch = (props) => {
    const renderSwitch = () => {
        if(props.value === true) {
            return (
                <div>
                    <label className="switch switch-text switch-success form-control-label">
                        <input onClick={props.onDeactivate} type="checkbox" className="switch-input form-check-input" value="on"
                               defaultChecked={true}/>
                        <span className="switch-label" data-on="On" data-off="Off"/>
                        <span className="switch-handle"/>
                    </label>
                </div>
            )
        } else {
            return (
                <div>
                    <label className="switch switch-text switch-success form-control-label">
                        <input onClick={props.onActivate} type="checkbox" className="switch-input form-check-input" value="on"
                               defaultChecked={false}/>
                        <span className="switch-label" data-on="On" data-off="Off"/>
                        <span className="switch-handle"/>
                    </label>
                </div>
            )
        }
    };

    return renderSwitch();
};

export default Switch;


// WEBPACK FOOTER //
// ./src/admin/components/Switch.js